import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

export type LastApp = 'crownbase' | 'stock';

const DEFAULT_COOKIE_NAME = 'rc_last_app';
const NINETY_DAYS_IN_SECONDS = 90 * 24 * 60 * 60;

// Remembers which app the user last used, on the parent domain so the signed-out page of any app can offer the right way back in.
@Injectable({ providedIn: 'root' })
export class LastAppCookieService {
  readonly #document = inject(DOCUMENT);

  // Each environment has its own name: they all share the crownbasenxt.be domain.
  read(name = DEFAULT_COOKIE_NAME): LastApp | null {
    const match = this.#document.cookie
      .split(';')
      .map(part => part.trim())
      .find(part => part.startsWith(`${name}=`));
    const value = match?.slice(name.length + 1);
    return value === 'crownbase' || value === 'stock' ? value : null;
  }

  write(app: LastApp, domain: string, name = DEFAULT_COOKIE_NAME): void {
    this.#document.cookie = `${name}=${app}; Domain=${domain}; Path=/; Max-Age=${NINETY_DAYS_IN_SECONDS}; Secure; SameSite=Lax`;
  }
}
